import { Helmet } from "react-helmet-async";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-page-modern">
      <Helmet>
        <title>Terms of Service | WLE Technology Ventures Sdn Bhd</title>
        <meta name="description" content="Terms of Service for WLE Technology Ventures Sdn Bhd and WLE Ventures. Agreement terms for tank fabrication and related services." />
        <link rel="canonical" href="https://wletec.com/terms-of-service" />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <Navigation />
      
      <main className="py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">Terms of Service</h1>
            <p className="text-muted-foreground">Last updated: December 13, 2025</p>
          </div>

          <div className="space-y-8">
            <Card>
              <CardHeader>
                <CardTitle>Agreement to Terms</CardTitle>
              </CardHeader>
              <CardContent>
                <p>
                  By accessing and using the WLE Technology Ventures Sdn Bhd and WLE Ventures website and services, you agree to be bound by these Terms of Service and all applicable laws and regulations.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Services Description</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p>WLE Technology Ventures Sdn Bhd and WLE Ventures provide:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Custom tank fabrication services</li>
                  <li>Electropolishing and mechanical polishing services</li>
                  <li>Engineering and design consultation</li>
                  <li>EPCC (Engineering, Procurement, Construction, Commissioning) solutions</li>
                  <li>Installation and maintenance services</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Quotations and Pricing</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <ul className="list-disc pl-6 space-y-2">
                  <li>All quotations are valid for 30 days unless otherwise specified</li>
                  <li>Prices are subject to change based on material costs and project specifications</li>
                  <li>Final pricing will be confirmed in written contracts</li>
                  <li>Additional charges may apply for design changes or scope modifications</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Payment Terms</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <ul className="list-disc pl-6 space-y-2">
                  <li>Payment terms will be specified in individual contracts</li>
                  <li>Deposits may be required before commencement of work</li>
                  <li>Progress payments may be required for large projects</li>
                  <li>Final payment is due upon completion and acceptance of work</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Quality and Warranty</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p>WLE Technology Ventures Sdn Bhd and WLE Ventures warrant that:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>All work will be performed in accordance with industry standards</li>
                  <li>Materials used will meet specified requirements</li>
                  <li>Workmanship will be free from defects for the agreed warranty period</li>
                  <li>All applicable certifications and testing will be provided</li>
                </ul>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Limitation of Liability</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p>
                  Our liability is limited to the contract value of the specific project. We are not liable for indirect, incidental, or consequential damages. Our warranty is limited to repair or replacement of defective work.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Intellectual Property</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p>
                  All designs, drawings, and specifications created by WLE Technology Ventures Sdn Bhd and WLE Ventures remain our intellectual property unless otherwise agreed in writing. Clients retain rights to their proprietary information shared with us.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Force Majeure</CardTitle>
              </CardHeader>
              <CardContent>
                <p>
                  We are not liable for delays or failures due to circumstances beyond our reasonable control, including natural disasters, government actions, labor disputes, or material shortages.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Governing Law</CardTitle>
              </CardHeader>
              <CardContent>
                <p>
                  These terms are governed by the laws of Malaysia. Any disputes will be subject to the jurisdiction of Malaysian courts.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardHeader>
                <CardTitle>Contact Information</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p>For questions about these Terms of Service, contact us:</p>
                <div className="space-y-4">
                  <div className="space-y-2">
                    <p><strong>WLE Technology Ventures Sdn. Bhd.</strong></p>
                    <p>202601037405 (1699500-H)</p>
                    <p>7, Jalan Utarid U5/17</p>
                    <p>Mahsing Integrated Industrial Park</p>
                    <p>Seksyen U5, 40150 Shah Alam, Selangor Darul Ehsan, Malaysia</p>
                    <p>Phone: +6011 3906 9019</p>
                    <p>Email: enquiry@wletec.com</p>
                  </div>
                  <div className="space-y-2 pt-4 border-t">
                    <p><strong>WLE Ventures (Malaysia)</strong></p>
                    <p>7, Jalan Utarid U5/17</p>
                    <p>Mahsing Integrated Industrial Park</p>
                    <p>Seksyen U5, 40150 Shah Alam, Selangor Darul Ehsan, Malaysia</p>
                    <p>Phone: +6011 3906 9019</p>
                    <p>Email: enquiry@wletec.com</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfService;